// @ services
const { get } = require('services/api');
// @ core
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');

const checkStatusInProgress = () => ({
    type: actionTypes.RA_CHECK_STATUS_REQUEST,
});

const checkStatusSuccess = response => ({
    type: actionTypes.RA_CHECK_STATUS_SUCCESS,
    payload: response.status,
});

const checkStatusFailure = error => ({
    type: actionTypes.RA_CHECK_STATUS_FAILURE,
    payload: error,
});

const checkStatus = accessToken => dispatch => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };

    dispatch(checkStatusInProgress());
    return get(apiURLBuilder.getURL('raCheckStatus'), requestData)
        .then(response => {
            dispatch(checkStatusSuccess(response.body));
        })
        .catch(error => {
            if (error.error) {
                dispatch(checkStatusFailure(error.error.description));
            } else {
                throw error;
            }
        });
};

export default {
    checkStatus,
};
